<script setup lang="ts">
import type { SubscriptionRelationLink } from '@entities/subscription'

import { OrderRelationLink } from '@shared/ui/links'
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'SubscriptionRelationsCell',
})

defineProps<{
  links: SubscriptionRelationLink[]
  emptyText: string
}>()
</script>

<template>
  <div
    v-if="links.length"
    class="subscription-relations-cell"
  >
    <template
      v-for="(link, index) in links"
      :key="link.id"
    >
      <OrderRelationLink
        v-if="link.href"
        :href="link.href"
        :text="link.text"
        :notes="link.notes"
      />
      <AppText
        v-else
        name="body1"
        color="slate-900"
      >
        {{ link.text }}
      </AppText>
      <AppText
        v-if="index < links.length - 1"
        name="body1"
        color="slate-900"
      >
        ,
      </AppText>
    </template>
  </div>
  <AppText
    v-else
    name="body1"
    color="slate-900"
  >
    {{ emptyText }}
  </AppText>
</template>

<style scoped lang="scss" src="./SubscriptionRelationsCell.scss" />
